import { Component, Input } from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';
import { eUserSubscription } from '../../models/user_information.enum';

@Component({
  selector: 'app-user-information',
  standalone: true,
  imports: [MatMenuItem],
  templateUrl: './user-information.component.html',
  styleUrl: './user-information.component.scss'
})
export class UserInformationComponent {
  @Input({ required: true }) userEmail = '';
  @Input({ required: true }) logOut!: () => Promise<void>;

  subscriptionTier = eUserSubscription.CLIENT_HOSTED;
  endDate = 'December 31, 2026';

  initLogout() {
    this.logOut().then();
  }
}
